<mat-card class="preview-card">
  <img [src]="imageUrl" mat-card-image class="preview-media" />
  <mat-card-content class="preview-content">
    <button
      type="button"
      *ngIf="showRemoveButton"
      mat-icon-button
      class="preview-content--remove-button"
      color="warn"
      (click)="clear()"
    >
      <sn-icon fontSet="fas" fontIcon="fa-xmark"></sn-icon>
    </button>
    <sn-icon *ngIf="icon" class="preview-content--icon" fontSet="fa" [fontIcon]="icon"></sn-icon>
    <div *ngIf="showTitle" class="preview-content--title fs-text-truncate">{{ file.name }}</div>
  </mat-card-content>
</mat-card>
